import { gql, TypedDocumentNode } from "@apollo/client";
import { isEmpty } from "@flaminem/utils";

import {
  IdentifiedCasesOptions,
  IdentifiedCasesQuery,
  IdentifiedCasesQueryVariables,
} from "src/graphql/anti-fraud/__generated__/graphql.ts";
import { caseFragment } from "src/graphql/anti-fraud/fragments/CaseFragment";
import { pageInfoFragment } from "src/graphql/anti-fraud/fragments/PageInfoFragment";
import { useFetchQuery } from "src/graphql/utils";
import { mapToCase } from "src/mappers/case.mappers";

const getIdentifiedCases = gql`
  query IdentifiedCases($identifierId: ID!, $options: IdentifiedCasesOptions!) {
    identifiedCases(identifierId: $identifierId, options: $options) {
      cases {
        ...CaseFragment
      }
      pageInfo {
        ...PageInfo
      }
    }
  }

  ${caseFragment}
  ${pageInfoFragment}
` as TypedDocumentNode<IdentifiedCasesQuery, IdentifiedCasesQueryVariables>;

const useIdentifiedCases = (
  variables: { identifierId: string; options: IdentifiedCasesOptions },
  options?: { skip: boolean | undefined }
) => {
  return useFetchQuery(getIdentifiedCases, {
    isEmpty: (data) => isEmpty(data?.identifiedCases?.cases),
    toData: (data) =>
      data
        ? {
            cases: data.identifiedCases.cases.map(mapToCase),
            pageInfo: data.identifiedCases.pageInfo,
          }
        : null,
    uiErrors: {
      fetchError: "FETCH-RELATED-CASES-ERROR",
    },
    queryOptions: {
      variables: variables,
      skip: options?.skip,
      fetchPolicy: "no-cache",
    },
  });
};

export default useIdentifiedCases;
